import React, { useEffect, useContext } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import FormLayout from "../components/layout/FormLayout";
import RegistrationContext from "../context/registration/registrationContext";
import RegistrationForm from "../components/RegistrationForm/RegistrationForm";
import queryString from "query-string";
import l4lLogo from "../img/l4l.png";
import Flexhighlogo from "../img/Flexhighlogo.png";
import stanzalogo from "../img/stanzalogo.png";
import elev8logo from "../img/elev8logo.png";
import holstonlogo from "../img/holstonlogo.png";
import pbialogo from "../img/PBIA.png";
import { brandDomains, fetchBrands } from "../components/brand";
import findBrand from "../components/findBrand";
// import {
//   brand_llac,
//   brand_learn4life,
//   brand_elev8,
//   brand_flexhigh,
//   brand_holston,
//   brand_stanza,
//   brand_pbia
// } from "../data/brands";

const RegistrationFormPage = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const registrationContext = useContext(RegistrationContext);

  const {
    formData,
  } = registrationContext;

  const { getSiteprogram, charterPreSelected, Siteprogram } =
    registrationContext;
  formData.learningCenterCharter =
    Siteprogram.charter && Siteprogram.charter.name;
  formData.learningCenterName = Siteprogram.name;
  const brandPhoto =
    Siteprogram.charter && Siteprogram.charter.brand.brandPhoto;

    useEffect(() => {
      const loadBrands = async () => {
        await fetchBrands();
      };
  
      loadBrands();
    }, []);
  
    const brand_holston = brandDomains.brand_holston?.name;
    const brand_learn4life = brandDomains.brand_learn4life?.name;
    const brand_elev8 = brandDomains.brand_elev8?.name;
    const brand_flexhigh = brandDomains.brand_flexhigh?.name;
    const brand_pbia = brandDomains.brand_holston?.name;
    const brand_stanza = brandDomains.brand_stanza?.name;

  useEffect(() => {
    var query = queryString.parse(location.search);
    if (query.site) {
      getSiteprogram(query.site);
    } else {
      navigate("/");
    }
    if (query.charter) {
      charterPreSelected(query.charter);
    }
  }, []);

  let brandLogo;
  switch (true) {
    
    case findBrand(brand_flexhigh):
      brandLogo = (
        <img
          src={Flexhighlogo}
          alt="Flexhigh Logo"
          height={"55px"}
          width={"200px"}
        />
      );
      break;
    case findBrand(brand_learn4life):
      brandLogo = <img src={l4lLogo} alt="Learn4Life Logo" />;
      break;
    case findBrand(brand_stanza):
      brandLogo = <img src={stanzalogo} height={"69px"} alt="Stanza Logo" />;
      break;
    case findBrand(brand_elev8):
      brandLogo = <img src={elev8logo} alt="Elev8 Logo" height={"69px"} />;
      break;
    case findBrand(brand_holston):
      brandLogo = <img src={holstonlogo} height={"69px"} alt="Holston Logo" />;
      break;
      case findBrand(brand_pbia):
      brandLogo = <img src={pbialogo} height={"69px"} alt="PBIA Logo" />;
      break;
    default:
      brandLogo = <img src={l4lLogo} alt="Learn4Life Logo" />;
      break;
  }

  return (
    <FormLayout>
      <div className="brand-header">
        <div className="text-center" style={{ marginTop: "10px" }}>
          {/* <Link to="/">{brandLogo}</Link> */}
          <Link to="/">
            {" "}
            <img
              src={brandPhoto}
              alt=""
              className="branding-logo"
              height={"69px"}
            />{" "}
          </Link>
        </div>
      </div>
      <div className="intro-box">
        <p className="text-center" style={{ fontSize: "20px", padding: "0em 2em"}}>
          Thank you for enrolling and choosing to be a part of{" "}
          {formData.learningCenterCharter}-{formData.learningCenterName}. We are
          thrilled to welcome you to our educational community! Your decision to
          join us marks the beginning of an exciting journey filled with growth,
          discovery, and new experiences. We look forward to supporting you as
          you pursue your academic and personal goals.
        </p>
      </div>

      <RegistrationForm />
    </FormLayout>
  );
};

export default RegistrationFormPage;

